export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13966.88396df3.jpg";